import { VCard } from 'vuetify/lib/components/VCard';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VDivider } from 'vuetify/lib/components/VDivider';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c(VCard, _vm._g(_vm._b({
    style: _vm.styles
  }, 'v-card', _vm.$attrs, false), _vm.$listeners), [_vm.hasOffset ? _c('helper-offset', {
    attrs: {
      "inline": _vm.inline,
      "full-width": _vm.fullWidth,
      "offset": _vm.offset
    }
  }, [!_vm.$slots.offset ? _c(VCard, {
    staticClass: "v-card--material__header",
    class: `elevation-${_vm.elevation}`,
    attrs: {
      "color": _vm.color,
      "dark": ""
    }
  }, [!_vm.title && !_vm.text ? _vm._t("header") : _c('span', [_c('h4', {
    staticClass: "text-h6 mb-2",
    domProps: {
      "textContent": _vm._s(_vm.title)
    }
  }), _c('p', {
    staticClass: "category",
    domProps: {
      "textContent": _vm._s(_vm.text)
    }
  })])], 2) : _vm._t("offset")], 2) : _vm._e(), _c(VCardText, [_vm._t("default")], 2), _vm.$slots.actions ? _c(VDivider, {
    staticClass: "mx-4"
  }) : _vm._e(), _vm.$slots.actions ? _c(VCardActions, [_vm._t("actions")], 2) : _vm._e()], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };